import { SVGAttributes } from "react";

export const ItemSingleIcon = (
  props: SVGAttributes<SVGElement> & { size: "regular" }
) => {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.391 7.022a.29.29 0 01.218 0l7.164 5.478-7.164 5.478s0 0 0 0a.111.111 0 01-.025.01.29.29 0 01-.193-.01L5.227 12.5l7.164-5.478zm.001-.001s0 0 0 0h0l-.607-.794.607.794z"
        stroke="currentColor"
        strokeWidth={2}
      />
    </svg>
  );
};
ItemSingleIcon.displayName = "ItemSingleIcon";
